import React, { ReactElement } from 'react';
import Block from '../../Layout/Block';
import DescriptionImage from '../../Layout/DescriptionImage/DescriptionImage';
import { bezirke } from '../../Layout/Footer/BezirkFilter';
import '../../Layout/Main.scss';
import '../home.scss';
import './BeliebteSuchen.scss';
import TrackableLink from '../../TrackableLink';

const BeliebteSuchen = (): ReactElement => (
  <div className="beliebteSuchenContainer" style={{ paddingBottom: '2rem' }}>
    <div className="p-grid">
      <div className="lg:col-6 titleSpacer" />
      <div className="lg:col-6">
        <div className="bigH1">Beliebte Suchen</div>
        <div className="spacer" />
      </div>
    </div>
    <div className="p-grid">
      <div className="lg:col-6 imageCol">
        <DescriptionImage
          link="/?zip=1020,1030,1110,1220,1230&amp;kaufen_mieten=buy"
          linkTitle="Neubauprojekte mit Eigentumswohnungen in 1100, 1140, 1210 und 1230 Wien"
          linkAriaLabel="Neubauprojekte mit Eigentumswohnungen in 1100, 1140, 1210 und 1230 Wien"
          src="/home/suche-eigentumswohnung-neubauprojekte-wien.png"
          alt="suche-eigentumswohnung-neubauprojekte-wien"
          descriptionTitle="Neubauprojekte mit Eigentumswohnungen in 1100, 1140, 1210 und 1230 Wien"
          description="© LIV Immobilienvermarktung GmbH"
          tintColor="#f9e7d4"
          textColor="#7c4e39"
        />
      </div>
      <div className="lg:col-6">
        <h2>Eigentumswohnungen nach Wiener Bezirken</h2>
        <Block>
          Unter folgenden Links finden Sie Neubauprojekte in Wien, bei denen der
          Bauherr die Errichtung von Eigentumswohnungen vorsieht. Derzeit wird
          in der Kategorie Eigentumswohnungen in Wien am öftesten nach den
          Bezirken 1020, 1100, 1140, 1210 und 1230 gesucht.
        </Block>

        <div className="p-grid">
          <div className="col-6">
            {bezirke
              .filter((bezirk) => bezirk.number < 1130)
              .map((bezirk) => (
                <div key={bezirk.number}>
                  <TrackableLink
                    to={`/${bezirk.link}&kaufen_mieten=buy`}
                    className="inlineLink"
                  >
                    {bezirk.name}
                  </TrackableLink>
                  <br />
                </div>
              ))}
            <br />
          </div>
          <div className="col-6">
            {bezirke
              .filter((bezirk) => bezirk.number >= 1130)
              .map((bezirk) => (
                <div key={bezirk.number}>
                  <TrackableLink
                    to={`/${bezirk.link}&kaufen_mieten=buy`}
                    className="inlineLink"
                  >
                    {bezirk.name}
                  </TrackableLink>
                  <br />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BeliebteSuchen;
